import * as React from "react";
import { Component } from "react";
import { hot } from "react-hot-loader";
import { BrowserRouter } from "react-router-dom";
import {Router} from "./Router";
import {initMcePlugins} from "./lib/mce";
import {MeComponent, UserDetailsFragment} from "../types.d";
import {WorkspaceStore} from "../stores/WorkspaceStore";
import {lazyInject} from "@intelingu/core/IoC/container";
import { ApolloProvider } from '@apollo/react-hooks';
import {observable} from "mobx";
import {graphql} from "../configs/graphql.client";
import {observer} from "mobx-react";

initMcePlugins();

export interface AppProps {
}

let logo = "logo.svg";

if (PROJECT_NAME_ENV === "Intelingu") logo = "logo.svg"
else if (PROJECT_NAME_ENV === "HSE-Methode") logo = "hse-logo.svg"

@observer class App extends Component<AppProps, undefined> {

    @lazyInject(WorkspaceStore) workspaceStore: WorkspaceStore;

    @observable ready = false;

    _renderContent(me: UserDetailsFragment) {
        return <BrowserRouter>
            <Router />
        </BrowserRouter>;
    }

    async componentDidMount() {
        await graphql.initialize();
        this.ready = true;
    }

    render() {
        if (!this.ready) {
            return null;
        }

        return <>
            <ApolloProvider client={graphql.client}>
                <MeComponent
                    client={graphql.client}
                    onCompleted={data => {
                        this.workspaceStore.user = data.me;
                    }}
                >
                    {result => {
                        return <>
                            { result.data ? this._renderContent(result.data.me) : (
                                <div style={{
                                    width: '100%',
                                    height: '100vh',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}><img alt={''} src={require('../../public/assets/images/' + logo)} width={250} /></div>
                            ) }
                        </>
                    }}
                </MeComponent>
            </ApolloProvider>
        </>
    }

}

export default hot(module)(App);
